import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import { createUserWithEmailAndPassword } from 'firebase/auth';

import { setDoc, doc } from 'firebase/firestore';

import { auth, db } from '../firebase_config';

import { toast } from 'react-toastify';

import * as yup from 'yup';

export const RegisterForm = () => {
  const schema = yup
    .object({
      email: yup.string().required('email is a required field').email('email is not valid'),
      password: yup.string().required('password is a required field').min(6, 'password must be at least 6 characters'),
    })
    .required();

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = (data) => {
    toast.success('Welcome to Hogwarts!', {
      position: 'top-center',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });
    createUserWithEmailAndPassword(auth, data.email, data.password)
      .then((cred) => {
        const docRef = doc(db, 'users', cred.user.uid);
        setDoc(docRef, {
          name: '',
          id: cred.user.uid,
          count: 0,
          sum: 0,
          wishList: [],
          cart: [],
        });
        reset();
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  return (
    <div className="min-w-320 min-h-260 bg-shadow border-2 border-transparent rounded-lg p-2.5 relative">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="my-2">
          <label htmlFor="email" className="h-11 w-78 bg-transparent font-poppins font-normal text-lg text-background">
            Enter your email
          </label>
          <br />
          <div className="flex flex-col">
            <input
              type="email"
              id="email"
              placeholder="Type here"
              className="h-11 w-78 bg-transparent border border-background rounded-3xl py-3 px-7 font-poppins font-normal text-base text-background placeholder:text-background placeholder:font-poppins placeholder:text-base"
              {...register('email')}
            />
            <span className="px-4 text-like">{errors.email?.message}</span>
          </div>
        </div>
        <div className="my-4">
          <label
            htmlFor="password"
            className="h-11 w-78 bg-transparent font-poppins font-normal text-lg text-background">
            Enter your password
          </label>
          <br />
          <div className="flex flex-col">
            <input
              type="password"
              id="password"
              placeholder="Password"
              className="h-11 w-78 bg-transparent border border-background rounded-3xl py-3 px-7 font-poppins font-normal text-base text-background placeholder:text-background placeholder:font-poppins placeholder:text-base"
              {...register('password')}
            />
          </div>
          <span className="px-4 text-like">{errors.password?.message}</span>
        </div>
        <input
          type="submit"
          className="mt-6 p-1 rounded-full h-10 w-28 flex justify-center items-center bg-gradient-to-r from-grStart to-grEnd font-poppins leading-5 border border-transparent text-font hover:bg-none duration-300 hover:border-borderColor hover:text-borderColor cursor-pointer"
        />
      </form>
    </div>
  );
};
